import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const store = new Vuex.Store({
    state:{
        showPanel: false,
        showDevelopPanel:false,
        thingXsearch:'',
        zeroCode:'',
        zeroCodeNum:'',
        thingxProjectLink:'',
        thingxProjectName: ''
    },
    getters:{
        getShowPanel:function (state) {
            return state.showPanel
        },
        getShowDevelopPanel:function (state) {
            return state.showDevelopPanel
        }
    },
    mutations:{
        setShowPanel(state){
            state.showPanel = !state.showPanel
        },
        setShowDevelopPanel(state){
            state.showDevelopPanel = !state.showDevelopPanel
        },
        setThingXsearch(state, resourceName){
            state.thingXsearch = resourceName;
        },
        setzeroCode(state, zeroCode){
            state.zeroCode = zeroCode
        },
        setzeroCodeNum(state, zeroCodeNum){
            state.zeroCodeNum = zeroCodeNum
        },
        setProjectLink(state, projectLink){
            state.thingxProjectLink = projectLink
        },
        setProjectName(state, projectName){
            state.thingxProjectName = projectName
        },
    },
    actions: {
        setShowPanel(context){
            context.commit('setShowPanel')
        },
        setShowDevelopPanel(context){
            context.commit('setShowDevelopPanel')
        }
    }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js